var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSalesloft = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#06492E",
    fillRule: "evenodd",
    d: "M11.876 10.28c0-2.158 2.1-3.9 4.788-3.9 3.444 0 5.545 1.576 6.72 9.79h.757l1.092-11.2c-7.813-2.655-17.389.166-17.557 8.214 0 8.712 14.028 8.712 14.028 16.677 0 2.323-2.1 3.9-4.452 3.9-6.216 0-7.644-5.144-7.98-10.537h-.756L6.5 33.344S11.12 36 16.076 36c5.965-.083 9.913-4.397 10.08-8.96 0-8.713-14.28-10.538-14.28-16.76",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4D625",
    fillRule: "evenodd",
    d: "M27.199 32.895c0-1.66 1.344-3.07 3.108-3.07 1.849 0 3.193 1.41 3.193 3.07a3.08 3.08 0 0 1-3.108 3.07c-1.933.082-3.193-1.411-3.193-3.07",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSalesloft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/salesloft.7202ad9b.svg";